import { useAnchorable } from '../../hooks/useAnchorable';

import { numberedList, numberedListContainer } from './NumberedList.css';
import type { PostNumberedListProps } from './NumberedList.types';

export {
  numberedList as postNumberedListClass,
  numberedListContainer as postNumberedListContainerClass,
} from './NumberedList.css';

export const PostNumberedList = ({
  element,
  children,
  // we don't want these extra props in the ...props rest since we're spreading it on a div
  isLive,
  isIndexingDisabled,
  rewriteImageSrc,
  homePath,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  ...props
}: PostNumberedListProps) => {
  const { anchorAttributes } = useAnchorable(element.attrs);

  return (
    <div {...anchorAttributes} className={numberedListContainer}>
      {/* spreading props on standard DOM elements causes React warnings and hydration errors */}
      <ol
        {...props}
        className={numberedList}
        {...(typeof element.attrs?.start === 'number' && { start: element.attrs.start })}
      >
        {children}
      </ol>
    </div>
  );
};
